import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchMenuItems,
  SearchMenuItemsVariables
} from "./types/SearchMenuItems";

export const searchMenuItems = gql`
  ${pageInfoFragment}
  query SearchMenuItems(
    $after: String
    $first: Int!
    $query: String!
    $menuId: ID
  ) {
    search: menuItemsByLevel(
      after: $after
      first: $first
      menuId: $menuId
      filter: { search: $query }
      level: [0, 1]
    ) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export default makeTopLevelSearch<SearchMenuItems, SearchMenuItemsVariables>(
  searchMenuItems
);
